// utils/italianHolidays.js
// Festività nazionali italiane e utility per il calendario

/**
 * Calcola la data di Pasqua per un dato anno (algoritmo di Gauss)
 */
export const getEasterDate = (year) => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31) - 1; // 0-indexed
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  
  return new Date(year, month, day);
};

/**
 * Restituisce tutte le festività italiane per un dato anno
 */
export const getItalianHolidays = (year) => {
  const easter = getEasterDate(year);
  const easterMonday = new Date(easter);
  easterMonday.setDate(easter.getDate() + 1);
  
  const holidays = [
    { date: new Date(year, 0, 1), name: "Capodanno", type: "national" },
    { date: new Date(year, 0, 6), name: "Epifania", type: "national" },
    { date: easter, name: "Pasqua", type: "national" },
    { date: easterMonday, name: "Lunedì dell'Angelo", type: "national" },
    { date: new Date(year, 3, 25), name: "Festa della Liberazione", type: "national" },
    { date: new Date(year, 4, 1), name: "Festa dei Lavoratori", type: "national" },
    { date: new Date(year, 5, 2), name: "Festa della Repubblica", type: "national" },
    { date: new Date(year, 7, 15), name: "Ferragosto", type: "national" },
    { date: new Date(year, 10, 1), name: "Tutti i Santi", type: "national" },
    { date: new Date(year, 11, 8), name: "Immacolata Concezione", type: "national" },
    { date: new Date(year, 11, 25), name: "Natale", type: "national" },
    { date: new Date(year, 11, 26), name: "Santo Stefano", type: "national" },
  ];
  
  return holidays;
};

/**
 * Verifica se una data è una festività italiana
 */
export const isItalianHoliday = (date) => {
  const year = date.getFullYear();
  const holidays = getItalianHolidays(year);
  
  return holidays.find(h => 
    h.date.getDate() === date.getDate() &&
    h.date.getMonth() === date.getMonth() &&
    h.date.getFullYear() === date.getFullYear()
  );
};

/**
 * Verifica se una data è domenica
 */
export const isSunday = (date) => {
  return date.getDay() === 0;
};

/**
 * Verifica se una data è sabato
 */
export const isSaturday = (date) => {
  return date.getDay() === 6;
};

/**
 * Restituisce le festività per un mese specifico
 */
export const getHolidaysForMonth = (year, month) => {
  const holidays = getItalianHolidays(year);
  return holidays.filter(h => h.date.getMonth() === month);
};

/**
 * Formatta una data come chiave stringa per confronti
 */
export const formatDateKey = (date) => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

/**
 * Crea una mappa delle festività per lookup veloce
 */
export const createHolidayMap = (year) => {
  const holidays = getItalianHolidays(year);
  const map = {};
  
  holidays.forEach(h => {
    const key = formatDateKey(h.date);
    map[key] = h;
  });
  
  return map;
};

// Export default con tutte le utility
export default {
  getEasterDate,
  getItalianHolidays,
  isItalianHoliday,
  isSunday,
  isSaturday,
  getHolidaysForMonth,
  formatDateKey,
  createHolidayMap
};
